import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * {@link https://www.rfc-editor.org/rfc/rfc5322 RFC 5322} standard email validation
 *
 * Playground: https://www.regextester.com/19
 *
 * @param str
 */
export function rfc5322(str: string): boolean {
  const pattern =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  return pattern.test(str);
}

/**
 * {@link https://datatracker.ietf.org/doc/html/rfc5322 RFC 5322} standard email validation
 *
 * Playground: https://www.regextester.com/19
 *
 * @param control
 */
export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const { value } = control;

  if (!value || rfc5322(value)) {
    return null;
  }

  return { email: true };
}
